<template>
<div>

  <div class="content content-boxed">
    <!-- Information du profile -->
    <div class="row">
      <div class="col-xs-12">

        <div class="block block-bordered">
          <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">
                      <li v-if="flagDisplayBanner===0">
                          <button type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>
                      <li v-if="flagDisplayBanner">
                          <button  type="button" @click="toggleDisplayBanner()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayBanner()">{{labelTitleBanner[actualLanguage]}}</h2>
            </div>

            <div v-if="flagDisplayBanner" class="block-content">

              <div class="row">
                <div class="col-xs-12">
                    <!-- Static Labels -->
                    <div class="block">


                        <div class="col-sm-12 col-md-6">
                          <p><button @click="getReportsHistory()" type="button" class="btn btn-success" name="button">{{labelButtonReadHistory[actualLanguage]}}</button></p>
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <h6>{{labelHistoryLength[actualLanguage]}}</h6>
                            <input v-model="historyLength" class="form-control align-center" type="test"  placeholder="">
                        </div>

                        <spinner v-if="reportsIsReading"></spinner>
                        <div v-else class="col-xs-12 col-md-12">

                          <div class="table-responsive push-50">
                              <table class="table table-bordered table-hover">
                                  <thead>
                                      <tr>
                                          <th class="text-center" style="width: 20%;">{{labelTabel01_Col01[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 30%;">{{labelTabel01_Col02[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 20%;">{{labelTabel01_Col03[actualLanguage]}}</th>
                                          <th class="text-center" style="width: 20%;">{{labelTabel01_Col04[actualLanguage]}}</th>
                                      </tr>
                                  </thead>
                                  <tbody>
                                      <tr v-for ="(report,index) in reportsList">
                                          <td class="text-center">{{report.report_id}}</td>
                                          <td class="text-center">
                                              <p v-for="transaction in report.linked_commissions">{{transaction.transactionId}}</p>
                                          </td>
                                          <td class="text-center">
                                            <h6>{{labelInvoiceAmount[actualLanguage]}}</h6>
                                            <p>{{report.total_amount}} $</p>
                                            <h6>{{labelInvoiceReferenceNumber[actualLanguage]}}</h6>
                                            <input v-model="report.invoice_reference_number" class="form-control align-center push" type="test"  placeholder="">
                                            <button  type="button" @click="saveReportReferenceNumber(index)" class="btn btn-xs align-center" name="buttonAddPlanItem">
                                            <i class="fa fa-floppy-o fa-1x push-5-r "></i>{{labelButtonInvoiceReferenceNumber[actualLanguage]}}</button> 
                                          </td>
                                          <td class="text-center">
                                            <i v-if="report.payment_done_by_evsens" class="fa fa-check-square"></i>
                                            <i v-else class="fa fa-times"></i>
                                            <h6>{{labelInvoiceReferenceNumber[actualLanguage]}}</h6>
                                            <p>{{report.payment_reference_number}}</p>
                                          </td>
                                      </tr>
                                  </tbody>
                              </table>

                          </div>

                        </div>
                    <!-- END Static Labels -->
                    </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>

import Spinner from '@/components/Spinner'

import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'GroupIndex',
  props: ['organization'],
  data() {
    return {
      flagDisplayBanner : 0,
      profileIsSaving : false,
      actualLanguage : "FR",
      labelTitleSection: {FR: 'Historique de rapport de commissions', EN: 'Commissions report history'},
      labelTitleBanner: {FR: 'Rapports de commissions', EN: 'Commissions reports'},


      reportsIsReading : true,
      reportsList : [],
      reportIsSaving : [],
      historyLength : 20,

      labelButtonReadHistory: {FR: "Lire l'historique de rapport", EN: 'Read report history'},
      labelHistoryLength: {FR: "Nombre de lignes lues", EN: 'Read lines'},

      labelTabel01_Col01: {FR: 'Rapport', EN: 'Report'},
      labelTabel01_Col02: {FR: 'Transaction liées', EN: 'Linked transaction'},
      labelTabel01_Col03: {FR: 'Facturation', EN: 'Billing'},
      labelTabel01_Col04: {FR: 'Paiement', EN: 'Payment'},
      labelTabel01_Col05: {FR: '', EN: ''},
      labelTabel01_Col06: {FR: 'Rapport lié', EN: 'Linked report'},
      labelAddToReport: {FR: 'Ajouter au rapport', EN: 'Add to report'},
      labelInvoiceAmount: {FR: 'Montant', EN: 'Amount'},

      labelInvoiceReferenceNumber: {FR: 'Numéro de référence', EN: 'Reference number'},
      labelButtonInvoiceReferenceNumber: {FR: 'Enregistrer', EN: 'Save'},

      messageAlertSelectLines: {FR: 'Vous devez sélectionner des transactions (colonne AJOUTER AU RAPPORT).',
                                 EN: 'You must select transactions lines (column ADD TO REPORT)'},
      messageConfirmCreateReport: {FR: 'Vous confirmer la création du rapport de commissions?',
                                 EN: 'Confirm the commission report generation?'},

    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData']),
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayBanner(){
      this.getReportsHistory()
      this.flagDisplayBanner = ~this.flagDisplayBanner
    },

    getReportsHistory(){
        var requestData = {'postAction':'IntegratorGetReportsHistory',
                          'organizationId':this.organization.organizationId,
                          'readItems':this.historyLength}
        this.reportsIsReading = true
        this.reportIsSaving = []
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                this.reportsList = response.data.ReportsList
                for(var m=0;m<this.reportsList.length;m++){
                  this.reportIsSaving.push(false)
                }
                this.reportsIsReading = false
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  this.reportsIsReading = false
                  }
            })   
    },

    saveReportReferenceNumber(index){
        var requestData = {'postAction':'IntegratorUpdateReportData',
                          'organizationId':this.organization.organizationId,
                          'reportData':this.reportsList[index]}
        this.$store.dispatch('sessionStore/postOrganization', requestData)
            .then((response) => {
            if(response.data.Code=='OK'){
                }
                else{
                  window.alert(response.data.PromptMessage[this.actualLanguage])
                  }
            })   
    },


    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()


    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>





// WEBPACK FOOTER //
// IntegratorCommissionsReports.vue?7db5f8c8